<template>
  <img
    :alt="asset.title"
    :height="asset.height"
    :src="asset.url"
    :width="asset.width"
  />
</template>

<script>
export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  }
};
</script>
